import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-30261579"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "recovery-container"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_5 = { class: "animate" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Recuperar contraseña", -1))
const _hoisted_7 = {
  key: 0,
  class: "form-group"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label-space" }, "Introduce tu email. Te enviaremos un enlace de recuperación.", -1))
const _hoisted_9 = { class: "feedback" }
const _hoisted_10 = {
  key: 2,
  class: "spacer"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "animate" }, "Ir a login.", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "animate" }, "Volver a inicio.", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "animate" }, "Olvidé mi contraseña.", -1))

import main from '@/data/main.js';
import { ref } from 'vue'
import RecoveryService from '@/services/RecoveryService'




export default /*#__PURE__*/_defineComponent({
  __name: 'RecoveryPass',
  setup(__props) {

const loading = ref(false)
const feedback = ref('')
const email = ref('')
const service = new RecoveryService()
const showForm =ref(true)

 const handleRecovery = async ()=>{
      loading.value= true
      await service.requestRecovery(email.value)
      feedback.value = "Petición recibida. Se ha enviado un email de recuperación."
      showForm.value =false
      loading.value = false
 }

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (loading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_icon, {
          name: "ri-loader-2-fill",
          animation: "spin",
          class: "icon"
        })
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("img", {
          src: _unref(main).LOGO_URI,
          class: "logo",
          width: "512"
        }, null, 8, _hoisted_3),
        _hoisted_4,
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("form", null, [
              _hoisted_6,
              (showForm.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _hoisted_8,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      placeholder: "ejemplo@ademass.com",
                      required: "",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
                      class: "test-email"
                    }, null, 512), [
                      [_vModelText, email.value]
                    ])
                  ]))
                : _createCommentVNode("", true),
              (showForm.value)
                ? (_openBlock(), _createElementBlock("input", {
                    key: 1,
                    type: "submit",
                    value: "Recuperar",
                    class: "go-btn",
                    onClick: _withModifiers(handleRecovery, ["prevent"])
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("p", _hoisted_9, _toDisplayString(feedback.value), 1),
              (feedback.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10))
                : _createCommentVNode("", true),
              _createElementVNode("footer", null, [
                _createVNode(_component_router_link, {
                  to: {name: 'auth'},
                  class: "animate no-underscore"
                }, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: {name: 'home'},
                  class: "animate no-underscore"
                }, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: {name: 'recovery'},
                  class: "animate no-underscore"
                }, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ]))
}
}

})